import axios from 'axios';
import CONFIG from '../config';

export function communications(headers) {
  return {
    get() {
      return new Promise((resolve, reject) => {
        axios
          .get(CONFIG.backendURL + CONFIG.endPoints.communicationsGet, headers)
          .then(result => {
            resolve(result.data.data);
          })
          .catch(error => {
            reject(error.response);
          });
      });
    },
    add(body) {
      return new Promise((resolve, reject) => {
        axios
          .post(CONFIG.backendURL + CONFIG.endPoints.communicationsAdd, body, headers)
          .then(result => {
            resolve(result.data.data);
          })
          .catch(error => {
            reject(error.response);
          });
      });
    }
  };
}
